module.exports = __webpack_public_path__ + "img/Hub bearing.f0e9de40.jpg";